<script>

	import StringLayoutEditor from './StringLayoutEditor';
	import DatePicker from '../DatePicker';
	import moment from 'moment';

	export default {

		components: {StringLayoutEditor, DatePicker},

		props: ['layoutId'],

		data() {
			return {
			    date: moment().format('DD-MM-YYYY'),
				firstStepVisible: true,
				secondStepVisible: false,
				newRevision: '',
				stringsLayout: this.layoutId,
				revision: {},
                payload: {
			        newRevision: this.newRevision,
                    validityDate: moment(this.date, 'YYYY-MM-DD')
                }
			}
		},

		methods: {
			createRevision() {
				swal.fire({
					title: 'Sei sicuro?',
					text: 'Una nuova revisione verrà creata',
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Si, creami tutto!'
				}).then(({value}) => {
				    if (value) {
                        let payload = {
                            newRevision: this.newRevision,
                            validityDate: this.reverseDate()
                        };

                        axios.post(`/strings-layouts/${this.stringsLayout}/revision`, payload)
                            .then((response) => {
                                this.revision = response.data;
                                this.firstStepVisible = false;
                                this.secondStepVisible = true;
                            })
                            .catch((error) => {
                                swal.fire('Cazzo Fai!', 'Hai rotto tutto!!', 'error'); //TODO: Gestire realmente l'errore!
                            });
                    } else {
                        console.log('Mi sono dismesso tutto!');
                    }
				});
				
			},

            reverseDate() {
			    return this.date.split('-').reverse().join('-');
            }
		}
	}
</script>